// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewSelectStyles } from "@awc/Overrides/Widgets/ProductList/ProductListViewSelect";
import IconPlpGrid from "@awc/XDL/Icons/IconPlpGrid";
import IconPlpRows from "@awc/XDL/Icons/IconPlpRows";
import IconPlpTable from "@awc/XDL/Icons/IconPlpTable";

import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 12px;
    `,
};

viewSelectStyles.listViewIcon = {
    src: IconPlpRows,
    size: 16,
};

viewSelectStyles.gridViewIcon = {
    src: IconPlpGrid,
    size: 16,
};

viewSelectStyles.tableViewIcon = {
    src: IconPlpTable,
    size: 16,
};

viewSelectStyles.listViewClickable = {
    css: css`
        order: 3;
    `,
};
viewSelectStyles.gridViewClickable = {
    css: css`
        order: 2;
    `,
};

viewSelectStyles.tableViewClickable = {
    css: css`
        order: 4;
    `,
};
